

/// <amd-module name="Environments/EnvironmentsCommon/EnvironmentBaseComponent" />
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";
import { MessagesStore } from "Environments/EnvironmentsCommon/MessagesStore";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { StoreManager } from "Environments/Flux/StoreManager";
import React = require("react");
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface IEnvironmentBaseComponentProperties extends IVssComponentProperties {
    keepMessageStore?: boolean;
}

export interface IEnvironmentBaseComponentState {
    errorMessages: { [key: string]: React.ReactNode };
}

export abstract class EnvironmentBaseComponent<P extends IEnvironmentBaseComponentProperties, S extends IEnvironmentBaseComponentState> extends VssComponent<P, S> {

    public constructor(props: P, context: IVssComponentContext) {
        super(props, context);
        this._instanceId = this.getInstanceId(context);
        this._messagesStore = StoreManager.CreateStore<MessagesStore>(MessagesStore, this._instanceId);
        this._messagesStore.addChangedListener(this.onMessagesStoreChange);
        this.state = {
            errorMessages: {}
        } as S;
    }

    public componentWillUnmount(): void {
        this._messagesStore.removeChangedListener(this.onMessagesStoreChange);
        if (!this.props.keepMessageStore) {
            StoreManager.DeleteStore<MessagesStore>(MessagesStore, this.props.instanceId);
        }
        super.componentWillUnmount();
    }

    protected getErrorMessageView(key: string, className?: string): React.ReactNode {
        let message = this.getMessage(key);
        if (message) {
            return (
                <div className="margin-bottom">
                    <MessageCard
                        className={className}
                        severity={MessageCardSeverity.Error}
                        onDismiss={() => ActionsHubManager.GetActionsHub<MessagesActions>(MessagesActions, this._instanceId).clearMessage.invoke(key)}>
                        {message}
                    </MessageCard>
                </div>
            );
        }
    }

    protected onMessagesStoreChange = (): void => {
        let errorMessages = this._messagesStore.getMessages();
        this.setState({ errorMessages: errorMessages });
    }

    public getMessage(key: string): React.ReactNode {
        if (this.state.errorMessages.hasOwnProperty(key)) {
            return this.state.errorMessages[key];
        }

        return undefined;
    }

    protected abstract getInstanceId(context: IVssComponentContext): string;

    protected _messagesStore: MessagesStore;
    protected _instanceId: string;
}
